import { render } from "./BlogPostCard.vue?vue&type=template&id=d008371c"
import script from "./BlogPostCard.vue?vue&type=script&lang=js"
export * from "./BlogPostCard.vue?vue&type=script&lang=js"

import "./BlogPostCard.vue?vue&type=style&index=0&id=d008371c&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__